export default __webpack_public_path__ + "static/distributors-blockchain-9438d111f20ebe461d205aba889360c4.png";